import { Company } from '../types/career'

const COMPANIES: Company[] = [
	{
		title: 'Фриланс',
		dateUp: 1561921200,
		dateDown: 1593457200,
		jobTitle: 'Фронтенд-разработчик',
		description: [
			'Создал информационный портал для института дополнительного образования.',
			'Сделал онлайн-магазин.',
			'Сделал 6 лендинг страниц.',
		],
	},
	{
		title: 'UNIT6',
		link: 'https://www.unit6.dev/',
		dateUp: 1593543600,
		dateDown: 1629658800,
		jobTitle: 'Младший фронтенд-разработчик',
		description: [
			'Участвовал в разработке 2-х проектов личных кабинетов.',
			'Участвовал в разработке 5 промо проектов.',
		],
	},
	{
		title: 'Сайтсофт',
		link: 'https://sitesoft.ru/',
		dateUp: 1629745200,
		dateDown: 1682899200,
		jobTitle: 'Фронтенд-разработчик',
		description: [
			'Разработал более 20 уникальных компонентов для конструктора сайтов SiteSofte Platform.',
			'Сделал 3 проекта верстки с нуля, в двух выступал в роли ведущего специалиста.',
			'Участвовал в поддержке и модернизации более 30 проектов.',
			'Создал 2 шаблона для дальнейших разработок:\n' +
				'1. Pug + Jquery + SCSS,\n' +
				'2. Vue + Nuxt + TS + SCSS.',
			'Разработал библиотеку для кросплатформенной печати документов, которая поддерживается в браузерах от IE 10 до всех современных (мобильных включительно).',
			'Занимаюсь редизайном, переводом на другие языки, модернизацией личного кабинета системы мониторинга и аналитики.',
		],
	},
	{
		title: 'ПАО "СБЕРБАНК"',
		link: 'http://www.sberbank.ru/ru/person',
		dateUp: 1682899200,
		isNowJob: true,
		jobTitle: 'Старший эксперт по технологиям',
		description: [
			'Разработка двух модулей для обеспечения непрерывной работы бизнесов.',
			'Планирование и контроль архитектуры проектов, выстраивание связи с бэкендом, решение технически сложных задач.',
			'Перекресное ревью с другими участиниками команды.',
			'Ввод разработанных продуктов в продакшен, обесепечение безопасности системы.',
		],
	},
]

export { COMPANIES }
